import type { SearchConfigType, SearchType } from 'src/types';

export const filterConfig: Partial<Record<SearchType, SearchConfigType>> = {
    recent_accessed: undefined,
    people: undefined,
    entity: {
        type: 'project_status',
        title: 'Status',
        filters: [
            { name: 'Planned', value: 'project_status:planned' },
            { name: 'Active', value: 'project_status:active' },
            { name: 'Completed', value: 'project_status:completed' },
            { name: 'BreakLine', value: undefined },
            { name: 'Archived', value: 'project_status:archived' }
        ]
    },
    item: {
        type: 'scene_status',
        title: 'Status',
        filters: [
            { name: 'Planned', value: 'scene_status:planned' },
            { name: 'Active', value: 'scene_status:active' },
            { name: 'Completed', value: 'scene_status:completed' },
            { name: 'BreakLine', value: undefined },
            { name: 'Archived', value: 'scene_status:archived' }
        ]
    }
};
